import { useState } from "react";
import intl from "react-intl-universal";
import { ScreenGreeting } from "../../../Components/Molecules";
import { useAuth } from "../../../Contexts/AuthContext";
import { useContaInternacionalBalances } from "../../../Hooks/useContaInternacionalBalances";
import { ContaInternacionalBalanceCards } from "./components/ContaInternacionalBalanceCards";
import { ContaInternacionalDepositarModal } from "./components/ContaInternacionalDepositarModal";
import { ContaInternacionalMovimentarModal } from "./components/ContaInternacionalMovimentarModal";
import { ContaInternacionalTransferirModal } from "./components/ContaInternacionalTransferirModal";
import { ContaInternacionalHistoryPanel } from "./components/ContaInternacionalHistoryPanel";
import { ContaInternacionalShortcutMenu } from "./components/ContaInternacionalShortcutMenu";
import { ContaInternacionalTodasMoedasModal } from "./components/ContaInternacionalTodasMoedasModal";
import { FxQuotesSection } from "./components/FxQuotesSection";

export const ContaInternacional = () => {
  const { hasPermission } = useAuth();
  const canTransfer = hasPermission("internationaltransfer");
  const [depositarModalOpen, setDepositarModalOpen] = useState(false);
  const [movimentarModalOpen, setMovimentarModalOpen] = useState(false);
  const [transferirModalOpen, setTransferirModalOpen] = useState(false);
  const [todasMoedasModalOpen, setTodasMoedasModalOpen] = useState(false);

  const {
    currencies,
    allCurrencies,
    totalBrl,
    loading,
    usingFallback,
    error,
    reloadBalances,
  } = useContaInternacionalBalances();

  return (
    <div className="w-full">
      <FxQuotesSection showViewAll={false} />

      <ScreenGreeting
        title={intl.get("contaInternacional.title")}
        subTitle={intl.get("contaInternacional.subtitle")}
      />

      <ContaInternacionalShortcutMenu
        onOpenDepositar={() => setDepositarModalOpen(true)}
        onOpenMovimentar={canTransfer ? () => setMovimentarModalOpen(true) : undefined}
        onOpenTransferir={canTransfer ? () => setTransferirModalOpen(true) : undefined}
      />

      <ContaInternacionalBalanceCards
        currencies={currencies}
        totalBrl={totalBrl}
        loading={loading}
        usingFallback={usingFallback}
        error={error}
        onRetry={reloadBalances}
        onViewAllCurrencies={() => setTodasMoedasModalOpen(true)}
      />

      <ContaInternacionalHistoryPanel />

      <ContaInternacionalDepositarModal
        open={depositarModalOpen}
        onClose={() => setDepositarModalOpen(false)}
      />

      {canTransfer ? (
        <ContaInternacionalMovimentarModal
          open={movimentarModalOpen}
          onClose={() => setMovimentarModalOpen(false)}
        />
      ) : null}

      {canTransfer ? (
        <ContaInternacionalTransferirModal
          open={transferirModalOpen}
          onClose={() => setTransferirModalOpen(false)}
        />
      ) : null}

      <ContaInternacionalTodasMoedasModal
        open={todasMoedasModalOpen}
        onClose={() => setTodasMoedasModalOpen(false)}
        currencies={allCurrencies}
        loading={loading}
      />
    </div>
  );
};

export { ContaInternacionalDetalhe } from "./ContaInternacionalDetalhe";
export { ContaInternacionalDepositar } from "./ContaInternacionalDepositar";
export { ContaInternacionalMovimentar } from "./ContaInternacionalMovimentar";
export { ContaInternacionalTransferir } from "./ContaInternacionalTransferir";
